import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container } from "semantic-ui-react";
import { withAuthorization } from "../../components/Session/withAuthorization";
import AnalysisLayout from "src/components/Analysis/AnalysisLayout";
import { Navigation } from "src/components/Navigation";
const AnalysisComponent = ({
  authUser,
  orgId,
  usersStatus,
  history,
  match,
  location,
}: any) => (
  <React.Fragment>
    <Navigation />
    <Container className="main-container">
      <AnalysisLayout
        orgId={orgId}
        authUser={authUser}
        usersStatus={usersStatus}
        match={match}
        history={history}
        location={location}
      />
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
  usersStatus: state.sessionState.usersStatus,
});

const authCondition = (authUser: any) => !!authUser;

const Analysis = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(AnalysisComponent));

export default Analysis;



// WEBPACK FOOTER //
// ./src/containers/Analysis/index.tsx